import { render, staticRenderFns } from "./EmailTemplateAdd.vue?vue&type=template&id=29e4a053&scoped=true&"
import script from "./EmailTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateAdd.vue?vue&type=style&index=0&id=29e4a053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e4a053",
  null
  
)

export default component.exports